import { StyledLayer } from './styled';
import { useLayer } from '../../hooks/useLayer';

const Layer = (props) => {
  const layerProps = useLayer(props);

  return <StyledLayer {...layerProps} />;
};

export default Layer;
